import { create } from "zustand";

const defaultSelectedOptions = [];
const defaultParsedResult = null;

const useHousePickStore = create((set) => ({
  userLatitude: null,
  userLongitude: null,
  selectedOptions: defaultSelectedOptions,
  parsedResult: defaultParsedResult,
  setUserCoordinates: (userLatitude, userLongitude) =>
    set({
      userLatitude: typeof userLatitude === "number" ? userLatitude : null,
      userLongitude: typeof userLongitude === "number" ? userLongitude : null,
    }),
  setSelectedOptions: (selectedOptions) =>
    set({
      selectedOptions: Array.isArray(selectedOptions) ? selectedOptions : defaultSelectedOptions,
    }),
  setParsedResult: (parsedResult) =>
    set({
      parsedResult: Array.isArray(parsedResult) ? parsedResult : defaultParsedResult,
    }),
  setHousePickState: ({ userLatitude, userLongitude, selectedOptions }) =>
    set({
      userLatitude: typeof userLatitude === "number" ? userLatitude : null,
      userLongitude: typeof userLongitude === "number" ? userLongitude : null,
      selectedOptions: Array.isArray(selectedOptions) ? selectedOptions : defaultSelectedOptions,
    }),
  resetHousePickState: () =>
    set({
      userLatitude: null,
      userLongitude: null,
      selectedOptions: defaultSelectedOptions,
      parsedResult: defaultParsedResult,
    }),
}));

export default useHousePickStore;
